import { Component, Input, SimpleChanges } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-cancellation-policy-popup',
  templateUrl: './cancellation-policy-popup.component.html',
  styleUrls: ['./cancellation-policy-popup.component.scss']
})
export class CancellationPolicyPopupComponent {
  @Input() cancelPolicies: any;
  @Input() checkInDate: string;
  timeZone: string = '';

  constructor(){}

  ngOnInit() {
    if(this.cancelPolicies){
      this.getTimezoneFromPolicies();
      this.convert3rdPolicy();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.cancelPolicies){
      this.getTimezoneFromPolicies();
      this.convert3rdPolicy();
    }
  }

  convert3rdPolicy(){
    if (this.cancelPolicies.length === 2) {
      const [first, second] = this.cancelPolicies;
    
      const isFirstItemMatch = first.from_day === null && first.to_day === 0;
      const isSecondItemMatch = second.from_day === 0 && second.to_day === 0;
    
      if (isFirstItemMatch && isSecondItemMatch) {
        this.cancelPolicies = [second]; // Giữ lại item 2
      }
    }
  }

  getDateBefore(daysAgo: number, baseDate: string): string {
    return moment(baseDate).subtract(daysAgo, 'days').format('YYYY-MM-DD');
  }
  
  getTimezoneFromPolicies() {
    const policyWithTime = this.cancelPolicies.find((p: { time: any; }) => p.time);
    if (!policyWithTime) return;
  
    const timeStr = policyWithTime.time;
    const match = timeStr.match(/([+-])(\d{2}):?(\d{2})?/);
  
    if (!match) return;
  
    const sign = match[1] === '+' ? '+' : '-';
    const hours = parseInt(match[2], 10);
  
    this.timeZone = `(UTC${sign}${hours})`;
  }
}
